import { StoreTemplate } from "@/templates/TemplateLoader";
import { ReactNode } from "react";
import ProfileLayout from "@/templates/black-and-white/elements/CustomerProfile/ProfileLayout";
import UserAccountElement from "@/templates/black-and-white/elements/CustomerProfile/UserAccount";
import UserAddressesElement from "@/templates/black-and-white/elements/CustomerProfile/UserAddresses";
import UserOrdersElement from "@/templates/black-and-white/elements/CustomerProfile/OrderHistory";
import UserOrderElement from "@/templates/black-and-white/elements/CustomerProfile/OrderDetails";
import UserReviewsElement from "@/templates/black-and-white/elements/CustomerProfile/UserReviews";
import DiscountsBreakdown from "@/templates/black-and-white/elements/DiscountsBreakdown";

const elements = {
  ProfileLayout,
  UserAccountElement,
  UserAddressesElement,
  UserOrderElement,
  UserOrdersElement,
  UserReviewsElement,
  DiscountsBreakdown,
};

export function MePagesLoader(props: { children: ReactNode }) {
  StoreTemplate.load("black-and-white", "me", elements);
  return props.children;
}
